import { render, staticRenderFns } from "./input-skill-pyramid.vue?vue&type=template&id=f45b829e&scoped=true&"
import script from "./input-skill-pyramid.vue?vue&type=script&lang=js&"
export * from "./input-skill-pyramid.vue?vue&type=script&lang=js&"
import style0 from "./input-skill-pyramid.vue?vue&type=style&index=0&id=f45b829e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f45b829e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/fcs/fcs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f45b829e')) {
      api.createRecord('f45b829e', component.options)
    } else {
      api.reload('f45b829e', component.options)
    }
    module.hot.accept("./input-skill-pyramid.vue?vue&type=template&id=f45b829e&scoped=true&", function () {
      api.rerender('f45b829e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/input-skill-pyramid.vue"
export default component.exports